import color from "./colors";

export const MONITORING_PIE_COLORS = [
  color.secondary,
  color.accent,
  color.green700,
  color.blue700,
  color.orange500,
  color.red600,
  color.yellow700,
  color.gray600,
];
